import Grid from '@mui/material/GridLegacy';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import Link from 'next/link';
import Image from 'next/image';
import React from 'react'
import { count, getBrand, isDefined } from '../../config/helpers';
import useWindowSize from '../../_hooks/useWindowSize';

import dynamic from "next/dynamic";
// import ParseHtml from '../../Custom/ParseHtml';
import { useTheme } from '@mui/material/styles';
import dayjs from 'dayjs';
import Head from 'next/head';

const ArticleArchives = dynamic(() => import("./ArticleArchives"));
const ProductCarousel = dynamic(() => import("../ProductComponent/Carousel/ProductCarousel"));
const ArticleSchema = dynamic(() => import("../Schemas/ArticleSchema"));
const BoxContainer = dynamic(() => import("../Reusables/BoxContainer"));

const SingleArticle = ({ props }) => {
    const {
        archive_first_key,
        article_dates,
        article,
        article_images,
        related_videos,
        related_products,
        breadcrumb,
        day,
        meta_desc,
        month,
        per_page,
        title,
        type,
        page_type,
        year,
        template_page_settings,
        extras
    } = props;

    const layout = template_page_settings.layout;
    const { isMobile } = useWindowSize();
    const theme = useTheme();

    return (<>
        <Head>
            <title>{`${article.title} - ${process.env.brand.brand_name}`}</title>
        </Head>
        <BoxContainer className={"mt-4"}>
            <ArticleSchema {...props} />
            <Grid columnSpacing={6} container>
                <Grid lg={8} xs={12} item>
                    <Box title={article.image} sx={{
                        height: {
                            xs: '250px',
                            lg: '400px'
                        }
                    }} className="position-relative">

                        <Image
                            lazy="true"
                            src={article.image}
                            alt={article.title}
                            title={article.title}
                            fill
                            sizes="(max-width: 768px) 100vw,
                                (max-width: 1200px) 50vw,
                                33vw"
                            quality={100}
                        />
                        <Box sx={{
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                            position: 'relative',
                            left: '2%',
                            top: '2%',
                            width: '50px',
                            maxWidth: '50px'
                        }} className="floating-calendar text-center p-2">
                            <Typography className="f-size_4">{dayjs(article.date).format('DD')}</Typography>
                            <Typography className="f-size_4">{dayjs(article.date).format('MMM')}</Typography>
                        </Box>
                        <Typography className="mt-3" variant="h4" component="h1">{article.title}</Typography>
                        <Typography color="primary" component="p" className="ml-3 mt-1"><i>{article.display_name}</i></Typography>

                    </Box>

                    <Typography className="mt-3" variant="h4" component="h3">
                        {article.title}
                    </Typography>
                    <Typography component="p" className="mt-2">
                        <Typography component="span">Post by: </Typography>
                        <Typography component="i" color="primary">{article.display_name}</Typography>
                        <Typography color="grey" className="ml-3" component="span">{dayjs(article.date).format('DD/MM/YYYY')}</Typography>
                    </Typography>

                    {/* <ParseHtml html={article.content}/> */}
                    <div dangerouslySetInnerHTML={{
                        __html: article.content
                    }} />

                    {/* UNDER MAIN BLOCK */}

                    {/* TABS */}


                    {/* TABS CONTENT */}
                    {/* TODO: find which image zoom will be used (fullscreen) */}
                    {(isDefined(related_videos) && count(related_videos) > 0 || isDefined(article_images) && count(article_images) > 0) && (
                        <div>
                            <ul>
                                {/* displaying tabs */}
                                {isDefined(article_images) && count(article_images) > 0 && (
                                    <li>
                                        {/* article images tab */}
                                        <Button variant="contained" color='primary'>Gallary Images</Button>
                                    </li>
                                )}
                                {isDefined(related_videos) && count(related_videos) > 0 && (
                                    <li>
                                        {/* related videos tab */}
                                        <Button variant="contained" color='primary'>Videos</Button>
                                    </li>
                                )}
                            </ul>

                            {isDefined(article_images) && count(article_images) > 0 && (
                                <Grid className="mt-2" container>
                                    {article_images.map((article_image, idx) => (
                                        <Grid key={article_image.title + '_' + idx} item>
                                            <Image
                                                lazy="true"
                                                src={`${article_image.image}`}
                                                alt={(article_image.image) + (article_image.description ? ` - ${article_image.description}` : '')}
                                                title={article_image.title}
                                                height={150}
                                                width={250}
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                            )}


                            {/* Check over with working videos  */}
                            {isDefined(related_videos) && count(related_videos) > 0 && (
                                <Grid className="mt-2" container>
                                    {related_videos.map((related_video, idx) => (
                                        <Grid item>
                                            <a class="rsImg" data-rsw="843" data-rsh="473" data-rsvideo={`https://www.youtube.com/watch?v=${related_video.video}?rel=0`} href={`https://i.ytimg.com/vi/${related_video.video}/maxresdefault.jpg`}>
                                                <div class="rsTmb">
                                                    <h5>{replaceAll(` - ${process.env.brand.brand_name}`, '', related_video.title)}</h5>
                                                </div>
                                            </a>
                                        </Grid>
                                    ))}
                                </Grid>
                            )}
                        </div>
                    )}




                </Grid>
                <Grid lg={4} xs={12} className="text-end" item>
                    {isMobile && <Box>
                        {/* related products */}
                        {isDefined(related_products) && count(related_products) > 0 && (
                            <>
                                {/* carousel */}
                                <Typography className="text-start mt-2" variant="h4" component="h4">Related Products</Typography>
                                <ProductCarousel
                                    productData={{
                                        ...related_products,
                                        extras,
                                    }}
                                    products={related_products}
                                />
                            </>
                        )}
                    </Box>}
                    {/* Archives */}
                    {!getBrand('EH') && (
                        <ArticleArchives
                            type={type}
                            article_dates={article_dates}
                        />
                    )}

                </Grid>
            </Grid>

            {!isMobile && <Box>
                {/* related products */}
                {isDefined(related_products) && count(related_products) > 0 && (
                    <>
                        {/* carousel */}
                        <Typography variant="h4" component="h4">Related Products</Typography>
                        <ProductCarousel
                            productData={{
                                ...related_products,
                                extras
                            }}
                            sectionID={3}
                            products={related_products}
                        />
                    </>
                )}
            </Box>}

        </BoxContainer>
    </>);
}

export default SingleArticle